import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

// Routing for 'ask-expert-professional' now lives in LeadsRoutingModule
// (Ask Expert Professional leads are contact_us records, filtered by page_source).
const routes: Routes = [];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AskExpertProfessionalRoutingModule {
}
